<template>
  <form-field-select
    :label="label"
    v-model="filterValue"
    placeholder="no filter"
    @change="handleInput"
  >
    <option
      v-for="option in options"
      :value="option.id"
      :key="option.id"
    >{{ option.label }}
    </option>
  </form-field-select>
</template>

<script>
export default {
  name: "FilterLeadDeal",
  props: {
    label: {
      type: String,
      default: "Leads or Deals"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].deals;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "deals",
          value
        ]);
      }
    },
    options() {
      return [
        {id: 0, label: "Leads & Deals"},
        {id: 1, label: "Leads Only"},
        {id: 2, label: "Deals Only"}
      ];
    },
    text() {
      if (this.filterValue === 1) return "Leads Only";
      if (this.filterValue === 2) return "Deals Only";
      return null;
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
